import { SVGSkeleton } from '@/components/atoms/Skeleton';
export const InvestViewSkeleton = () => <div data-sentry-component="InvestViewSkeleton" data-sentry-source-file="Skeleton.tsx">
    <div className="relative flex flex-col">
      <div className="flex flex-col w-full px-[3.25rem]">
        <SVGSkeleton className="w-[200px] h-[14px]" data-sentry-element="SVGSkeleton" data-sentry-source-file="Skeleton.tsx" />
        <div className="w-[200px] h-[40px] mt-[10px]">
          <SVGSkeleton className="w-[200px] h-[40px]" data-sentry-element="SVGSkeleton" data-sentry-source-file="Skeleton.tsx" />
        </div>

        <div className="w-full inline-flex justify-start gap-x-[40px] mt-[30px]">
          {Array.from({
          length: 2
        }).map(() => <div key={crypto.randomUUID()} className="">
              <div className="w-full inline-flex justify-start">
                <SVGSkeleton className="w-[20px] h-[20px] mr-[8px]" />
                <SVGSkeleton className="w-[60px] h-[20px]" />
              </div>
              <SVGSkeleton className="w-[110px] h-[20px]" />
            </div>)}
        </div>
      </div>

      <div className="flex flex-col w-full mt-[30px]">
        <SVGSkeleton className="w-full h-[350px]" data-sentry-element="SVGSkeleton" data-sentry-source-file="Skeleton.tsx" />
      </div>

      <div className="flex flex-col w-full px-[3.25rem]">
        <div className="w-full mb-4 mt-[50px]">
          {Array.from({
          length: 3
        }).map(() => <div key={crypto.randomUUID()} className="w-full h-[35px] flex flex-row justify-between items-center !py-[10px] mb-4">
              <SVGSkeleton className="w-[30px] h-[30px]" />
              <p className="w-full text-left ml-4">
                <SVGSkeleton className="w-[200px] h-[30px]" />
              </p>
              <SVGSkeleton className="w-[15px] h-[15px]" />
            </div>)}
        </div>
      </div>

      <div className="flex flex-col w-full mt-[25px] px-[3.25rem]">
        <SVGSkeleton className="w-full h-[120px]" data-sentry-element="SVGSkeleton" data-sentry-source-file="Skeleton.tsx" />
      </div>

      <div className="w-full h-[200px]" />
    </div>
  </div>;